<template>
  <layout-main-inner title="基础设置">
    <layout-card-wrap>
      <el-row :gutter="20">
        <el-col :md="6">
          <subject-card :config="brand" />
        </el-col>
      </el-row>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import SubjectCard from './busi/subject-card.vue'
const imgaePng = require('../../../assets/images/cate.png')
export default {
  name: 'ExamConfig',
  components: { SubjectCard },
  data() {
    return {
      brand: { title: '考试科目', info: '用于鉴定师培训的考试科目设置', image: imgaePng }
    }
  }
}
</script>
